import React from 'react';
import { Helmet } from 'react-helmet-async';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { faqDe } from '../utils/faq';

// Bloc « Questions fréquentes » d'une page. Les réponses sont affichées en clair (pas d'accordéon :
// le texte doit être lisible sans clic par les moteurs et les assistants IA) et doublées du
// balisage schema.org FAQPage. `page` : clé de faq.json › pages ; ou `items` : liste explicite.
// Une seule FAQ balisée par page (balise=false pour un second bloc).
export const faqJsonLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map(({ q, a }) => ({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a } })),
});

const Faq = ({ page, items, titre = 'Questions fréquentes', balise = true, niveau = 'h2' }) => {
  const questions = items || faqDe(page);
  if (questions.length === 0) return null;
  return (
    <Box component="section" sx={{ maxWidth: 820, margin: '56px auto 0' }}>
      {balise && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(faqJsonLd(questions))}</script>
        </Helmet>
      )}
      {titre && <Typography variant="h4" component={niveau} sx={{ textAlign: 'center', marginBottom: 3 }}>{titre}</Typography>}
      {questions.map(({ id, q, a }) => (
        <Box key={id || q} sx={{ marginBottom: 3 }}>
          <Typography component="h3" sx={{ fontWeight: 600, fontSize: '1.05rem !important', color: '#3a2b2b !important', marginBottom: 0.5 }}>{q}</Typography>
          <Typography sx={{ lineHeight: 1.7 }}>{a}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Faq;
